export const referenceCategories = [
  { key: "kakelugn", title: "Kakelugnar", folder: "kakelugn" },
  { key: "insatser", title: "Insatskaminer", folder: "insatser" },
  { key: "kaminer", title: "Kaminer", folder: "kaminer" },
  { key: "bakugn", title: "Bakugnar", folder: "vedspis" },
  { key: "vedspis", title: "Vedspisar", folder: "vedspis" },
  { key: "skorsten", title: "Skorstenar", folder: "skorsten" },
  { key: "skorstensrenovering", title: "Skorstensrenovering", folder: "skorstenrenovering", galleryKey: "skorstenrenovering" },
  { key: "murputs", title: "Mur & puts", folder: "murputs" }
];
